import {
  BookOpenIcon,
  ChartNoAxesColumnIcon,
  CheckCircle2Icon,
  FileTextIcon,
  GaugeIcon,
  HashIcon,
  LayersIcon,
  LightbulbIcon,
  ListChecksIcon,
  MailIcon,
  MessageCircleQuestionIcon,
  MessageSquareIcon,
  PaletteIcon,
  PinIcon,
  SendIcon,
  ShieldCheckIcon,
  SparklesIcon,
  TriangleAlertIcon,
  UserPlusIcon,
  UsersIcon,
  ZapIcon,
  type LucideIcon,
} from "lucide-react";

import type { MessageKey } from "~/i18n";

export type MorrowWorkspaceAgentSkill = {
  readonly icon: LucideIcon;
  readonly labelKey: MessageKey;
};

export type MorrowWorkspaceAgent = {
  readonly id: string;
  readonly color: string;
  readonly imageSrc: string;
  readonly roleKey: MessageKey;
  readonly blurbKey: MessageKey;
  readonly skills: ReadonlyArray<MorrowWorkspaceAgentSkill>;
};

export const MORROW_WORKSPACE_AGENTS: ReadonlyArray<MorrowWorkspaceAgent> = [
  {
    id: "mor",
    color: "blue",
    imageSrc: "/brand/agents/blue.png",
    roleKey: "agents.mor.role",
    blurbKey: "agents.mor.blurb",
    skills: [
      { icon: UsersIcon, labelKey: "agents.mor.skill.team" },
      { icon: ZapIcon, labelKey: "agents.mor.skill.pickup" },
      { icon: CheckCircle2Icon, labelKey: "agents.mor.skill.result" },
    ],
  },
  {
    id: "hr",
    color: "pink",
    imageSrc: "/brand/agents/pink.png",
    roleKey: "agents.hr.role",
    blurbKey: "agents.hr.blurb",
    skills: [
      { icon: UserPlusIcon, labelKey: "agents.hr.skill.hiring" },
      { icon: SparklesIcon, labelKey: "agents.hr.skill.onboarding" },
      { icon: ShieldCheckIcon, labelKey: "agents.hr.skill.health" },
    ],
  },
  {
    id: "marketing",
    color: "red",
    imageSrc: "/brand/agents/red.png",
    roleKey: "agents.marketing.role",
    blurbKey: "agents.marketing.blurb",
    skills: [
      { icon: BookOpenIcon, labelKey: "agents.marketing.skill.story" },
      { icon: PaletteIcon, labelKey: "agents.marketing.skill.campaigns" },
      { icon: FileTextIcon, labelKey: "agents.marketing.skill.brief" },
    ],
  },
  {
    id: "product",
    color: "purple",
    imageSrc: "/brand/agents/purple.png",
    roleKey: "agents.product.role",
    blurbKey: "agents.product.blurb",
    skills: [
      { icon: LayersIcon, labelKey: "agents.product.skill.scope" },
      { icon: PinIcon, labelKey: "agents.product.skill.priority" },
      { icon: ListChecksIcon, labelKey: "agents.product.skill.ship" },
    ],
  },
  {
    id: "strategy",
    color: "navy",
    imageSrc: "/brand/agents/navy.png",
    roleKey: "agents.strategy.role",
    blurbKey: "agents.strategy.blurb",
    skills: [
      { icon: LayersIcon, labelKey: "agents.strategy.skill.options" },
      { icon: TriangleAlertIcon, labelKey: "agents.strategy.skill.risks" },
      { icon: LightbulbIcon, labelKey: "agents.strategy.skill.plan" },
    ],
  },
  {
    id: "finance",
    color: "yellow",
    imageSrc: "/brand/agents/yellow.png",
    roleKey: "agents.finance.role",
    blurbKey: "agents.finance.blurb",
    skills: [
      { icon: GaugeIcon, labelKey: "agents.finance.skill.spend" },
      { icon: ChartNoAxesColumnIcon, labelKey: "agents.finance.skill.usage" },
      { icon: HashIcon, labelKey: "agents.finance.skill.numbers" },
    ],
  },
  {
    id: "sales",
    color: "orange",
    imageSrc: "/brand/agents/orange.png",
    roleKey: "agents.sales.role",
    blurbKey: "agents.sales.blurb",
    skills: [
      { icon: ChartNoAxesColumnIcon, labelKey: "agents.sales.skill.pipeline" },
      { icon: SendIcon, labelKey: "agents.sales.skill.outreach" },
      { icon: CheckCircle2Icon, labelKey: "agents.sales.skill.close" },
    ],
  },
  {
    id: "support",
    color: "green",
    imageSrc: "/brand/agents/green.png",
    roleKey: "agents.support.role",
    blurbKey: "agents.support.blurb",
    skills: [
      { icon: MailIcon, labelKey: "agents.support.skill.inbox" },
      { icon: MessageSquareIcon, labelKey: "agents.support.skill.slack" },
      { icon: MessageCircleQuestionIcon, labelKey: "agents.support.skill.answers" },
    ],
  },
];

export type MorrowDailyFlow = {
  readonly id: string;
  readonly labelKey: MessageKey;
  readonly promptKey: MessageKey;
};

export const MORROW_DAILY_FLOWS: ReadonlyArray<MorrowDailyFlow> = [
  {
    id: "briefing",
    labelKey: "messages.flow.briefing",
    promptKey: "messages.flow.briefingPrompt",
  },
  {
    id: "inbox",
    labelKey: "messages.flow.inbox",
    promptKey: "messages.flow.inboxPrompt",
  },
  {
    id: "calendar",
    labelKey: "messages.flow.calendar",
    promptKey: "messages.flow.calendarPrompt",
  },
];
